(() => {
  // Aquarium Builder "Complete your kit" and "Customers also bought" blocks (snippets/ab-cart-kit-upsell.liquid,
  // ab-cart-also-bought.liquid, ab-popup-also-bought.liquid): switches kit level, shows the rest of a long list,
  // and adds picks to the cart.
  if (window.__abUpsell) return;
  window.__abUpsell = 1;

  const parse = value => value.split(',').filter(Boolean).map(part => {
    const [id, qty] = part.split(':');
    return {id: Number(id), quantity: Number(qty) || 1};
  });

  async function add(button) {
    const box = button.closest('[data-abu]');
    const status = box.querySelector('[data-abu-status]');
    const items = parse(button.dataset.abuAdd);
    // A whole tier is tagged like the builder's own "Add tank + kit", so the cart's kit group shows its level.
    if (button.dataset.abuKit) items.forEach(item => { item.properties = {_builder_kit: button.dataset.abuKit}; });
    button.disabled = true;
    button.classList.add('is-loading');
    if (status) status.textContent = '';
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      // ?ab=upsell keeps the add-to-cart popup (ab-add-popup.js) from opening for our own adds.
      const response = await fetch(`${root}cart/add.js?ab=upsell`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items})
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Sorry, that couldn\'t be added to your cart.');
      }
      // The drawer refreshes itself on this event; the popup marks the pick as added; the cart page reloads.
      if (box.closest('[data-abp]')) {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        document.dispatchEvent(new CustomEvent('abp:added', {detail: {button}}));
      } else if (box.closest('.quick-cart')) {
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      } else {
        window.location.reload();
      }
    } catch (error) {
      if (status) status.textContent = error.message;
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', event => {
    const tier = event.target.closest('[data-abu-tier]');
    if (tier) {
      const box = tier.closest('[data-abu]');
      box.querySelectorAll('[data-abu-tier]').forEach(b => b.setAttribute('aria-selected', b === tier ? 'true' : 'false'));
      box.querySelectorAll('[data-abu-panel]').forEach(panel => { panel.hidden = panel.dataset.abuPanel !== tier.dataset.abuTier; });
      return;
    }
    const more = event.target.closest('[data-abu-more]');
    if (more) {
      more.closest('[data-abu-panel]').classList.add('is-open');
      return;
    }
    const button = event.target.closest('[data-abu] [data-abu-add]');
    if (button) {
      event.preventDefault();
      add(button);
    }
  });
})();
